import {createBrowserHistory} from 'history';
const browserHistory = createBrowserHistory();

export default function redirect(to) {
    browserHistory.push(to);
}
